import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ConfirmationModal = ({ 
  show, 
  onConfirm, 
  onCancel, 
  title = "Confirm Details",
  message = "Please confirm your details. After submission, changes will not be permitted.",
  confirmText = "Yes",
  cancelText = "No",
  isLoading = false
}) => {
  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Body className="text-center p-4">
        <div className="warning-icon mb-3">
          <i className="fas fa-exclamation-triangle" style={{ fontSize: '48px', color: '#ffc107' }}></i>
        </div>
        <p className="mb-4" style={{ fontSize: '16px', color: '#333' }}>
          {message}
        </p>
        <div className="d-flex justify-content-center gap-3">
          <Button
            variant="outline-secondary"
            onClick={onCancel}
            disabled={isLoading}
            style={{ minWidth: '120px' }}
          >
            {cancelText}
          </Button>
          <Button
            variant="warning"
            onClick={onConfirm}
            disabled={isLoading}
            style={{ minWidth: '120px' }}
          >
            {isLoading ? 'Processing...' : confirmText}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmationModal;
